/**
 * Create Audit Layout Route
 * Two-column layout with draft audits sidebar and main content area
 */

import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceSlug/audits/new")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Coming soon...</div>;
}
